import { render, staticRenderFns } from "./Purposes.vue?vue&type=template&id=d001ca04&scoped=true"
import script from "./Purposes.vue?vue&type=script&lang=js"
export * from "./Purposes.vue?vue&type=script&lang=js"
import style0 from "./Purposes.vue?vue&type=style&index=0&id=d001ca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d001ca04",
  null
  
)

export default component.exports